module.exports = __webpack_public_path__ + "img/whatsapp.a652264f.svg";